import React from "react";
import {Col, Row} from "reactstrap";
import IconButton from "../../../../base/button/icon_button";
import {ArrowBack} from "@mui/icons-material";
import {ReactComponent as OnlinePaymentImage} from "../../../../../../assets/images/art-like/online-payments.svg";
import Button from "../../../../base/button/button";
import {AccountingPaymentOptions} from "../../../../../../core/constants/enums";
import {ReactComponent as OtherPaymentImage} from "../../../../../../assets/images/art-like/other-payments.svg";
import classnames from "classnames";

const PayCustomerOrderPaymentMethodSelectionSection = ({canGoBack, goBack, onSelect}) => {

    return (
        <>
            {
                canGoBack &&
                <Row className='mt-2 no-gutters w-100'>
                    <IconButton
                        onPressed={() => goBack()}
                        color={'secondary'}
                    >
                        <ArrowBack className={'icon normal'}/>
                    </IconButton>
                    <p className={classnames('text-md text-color-1 ml-2')}>
                        Please select your payment method.
                    </p>
                </Row>
            }
            <Row
                className='mt-2 no-gutters w-100'
                style={{minHeight: '300px'}}
            >
                <Col xs={6}
                     className={'d-flex flex-column align-items-center w-100'}>
                    <p className={'text-md font-weight-semi-bold mt-4 mb-3'}>
                        Online Payment
                    </p>
                    <div className={'d-flex justify-content-center align-items-center'}>
                        <OnlinePaymentImage className={'p-2'}/>
                    </div>
                    <div className={'d-flex justify-content-center w-100 align-items-center px-4'}>
                        <Button
                            onClick={() => onSelect(AccountingPaymentOptions.onlinePayment)}
                            color={'primary'}
                            variant={'contained'}
                            className='w-100'
                        >
                            Proceed
                        </Button>
                    </div>
                </Col>
                <Col xs={6}
                     className={'d-flex flex-column align-items-center w-100'}>
                    <p className={'text-md font-weight-semi-bold mt-4 mb-3'}>
                        Other Payments
                    </p>
                    <div className={'d-flex justify-content-center align-items-center'}>
                        <OtherPaymentImage className={'p-2'}/>
                    </div>
                    <div className={'d-flex justify-content-center w-100 align-items-center px-4'}>
                        <Button
                            onClick={() => onSelect(AccountingPaymentOptions.otherPayments)}
                            variant={'contained'}
                            color={'primary'}
                            className='font-weight-bold text-xs w-100'
                        >
                            Proceed
                        </Button>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default PayCustomerOrderPaymentMethodSelectionSection;
